module.exports = __webpack_public_path__ + "static/media/logo.e07ede4d.png";